import {
  FETCH_INDUSTRY,
  FETCH_INDUSTRY_SUCCESS,
  FETCH_INDUSTRY_ERROR,
  ADD_INDUSTRY,
  ADD_INDUSTRY_SUCCESS,
  ADD_INDUSTRY_ERROR,
  UPDATE_INDUSTRY,
  UPDATE_INDUSTRY_SUCCESS,
  UPDATE_INDUSTRY_ERROR,
  RESET_UPDATE_INDUSTRY,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  updating: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_INDUSTRY: {
      return {...state, error: '', loading: true, payload: {}};
    }
    case ADD_INDUSTRY: {
      return {...state, error: '', updating: true};
    }
    case UPDATE_INDUSTRY: {
      return {...state, error: '', updating: true};
    }
    case FETCH_INDUSTRY_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case ADD_INDUSTRY_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case UPDATE_INDUSTRY_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }};
    }
    case FETCH_INDUSTRY_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_INDUSTRY_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case UPDATE_INDUSTRY_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_UPDATE_INDUSTRY: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
